import React from 'react'
import { BsInstagram, BsLinkedin, BsYoutube } from "react-icons/bs"

function SocialMedia() {
  return (
   <div className="app__social">
    <a href="https://www.instagram.com/kev_antony/" target="_blank">
    <div>
      <BsInstagram />
    </div>
    </a>
    <a href="https://www.linkedin.com/in/antoine-choula/" target="_blank">
    <div>
      <BsLinkedin />
    </div>
    </a>
    <a href="https://www.youtube.com/channel/UCFgk6Ai8WC873gCknxhy1lw" target="_blank">
    <div>
      <BsYoutube />
    </div>
    </a>
  </div>
  )
}

export default SocialMedia